;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.submit = (function () {
    const initialize = function () {
      $('.js-submit').on('click', function (e) {
        e.preventDefault()
        $(this).siblings('input').click()
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.submit.initialize()
  })
}(jQuery, window))
